import { createSlice } from "@reduxjs/toolkit";
import { getAutomatedWorkflowsAPI, createAutomatedWorkflowAPI } from "./apis/automated-workflows";

const initialState = {
    pending: false,
    error: null, // null=정상, 숫자=HTTP status, true=상태코드 불명
    data: [],
};

const automatedWorkflowsSlice = createSlice({
    name: "automatedWorkflows",
    initialState,
    reducers: {
        resetAutomatedWorkflows: () => initialState,
        pending(state) {
            state.pending = true;
            state.error = null;
        },
        success(state, action) {
            state.pending = false;
            state.error = null;
            state.data = action.payload;
        },
        failure(state, action) {
            state.pending = false;
            state.error = action.payload; // HTTP status code 유지
        },
    },
});

const { pending, success, failure } = automatedWorkflowsSlice.actions;
export const { resetAutomatedWorkflows } = automatedWorkflowsSlice.actions;

/**
 * Automated Workflow 목록 조회 (페이지 단위).
 * - name / statuses 는 서버 검색, limit / nextToken 으로 토큰 페이지네이션(한 페이지씩 조회).
 * - 응답(response)을 resolve 하여 호출 측이 response.data.nextToken 으로 페이지별 토큰을 관리한다.
 * - 실패 시 error 에 HTTP status code 를 저장(상태코드별 에러 컴포넌트 렌더용).
 */
export const getAutomatedWorkflows = (params) => (dispatch, getState) => {
    const { stage, project } = getState();
    dispatch(pending());
    return getAutomatedWorkflowsAPI(stage.id, stage.endpoint, project.id, params)
        .then((response) => {
            dispatch(success(response.data?.results ?? []));
            return response; // 호출 측 nextToken 관리용 response 그대로 resolve
        })
        .catch((error) => {
            dispatch(failure(error?.response?.status ?? true));
            throw error;
        });
};

/**
 * Automated Workflow 생성.
 * - 리듀서 상태는 변경하지 않고 API Promise 만 반환 → 호출 측에서 목록 재조회/알림 처리.
 * @param {object} data - { name, description } (description optional)
 */
export const createAutomatedWorkflow = (data) => (dispatch, getState) => {
    const { stage, project } = getState();
    return createAutomatedWorkflowAPI(stage.id, stage.endpoint, project.id, data);
};

export default automatedWorkflowsSlice.reducer;
